"use strict";
'use strict';

var format = require('@ark-ui/react/format');

const FormatNumber = format.Format.Number;
const FormatByte = format.Format.Byte;

exports.FormatByte = FormatByte;
exports.FormatNumber = FormatNumber;
